import { Component, Input, ViewChild } from '@angular/core';
import { AddressModel } from 'src/app/core/models/address.model';
import { GlobalComponent } from 'src/app/global-component';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss']
})
export class AddressComponent {

  @Input() addressModel: AddressModel = new AddressModel();
  @Input() disableInputs: boolean = false; 
  @Input() submitted: boolean = false; 
  @Input() includeValidation: boolean = false;
  @Input() validationValue: boolean = false;
  
  @ViewChild('streetNum') public streetNum: any;
  @ViewChild('street') public street: any;
  @ViewChild('city') public city: any;
  @ViewChild('postalcode') public postalcode: any;
  @ViewChild('province') public province: any;
  @ViewChild('country') public country: any;
  
  provinceList: any = GlobalComponent.provinceList;
  statesList: any = GlobalComponent.statesList;
  countryList: any = GlobalComponent.countryList;

  
  public addressPattern = { '0':  GlobalComponent.stringPattern };


  changeProvince(event: any){
    if(this.addressModel){
      this.addressModel.province = event.target.value;
    }
  } 

  changeCountry(event: any){
    if(this.addressModel){
      this.addressModel.country = event.target.value;
    }
  } 
}
